import { useEffect, useState } from 'react';
import { useGameStore } from '../../core/store';
import { useTunnelExitStore } from './tunnelExitStore';
import { MobileTouchControls } from '../ui/mobile/MobileTouchControls';
import { NextSkillCard } from './NextSkillCard';
import { TunnelObjectiveTip } from './TunnelObjectiveTip';
import './tunnel-hud-mobile.css';

const STAMINA_SEGS = 12;

export function TunnelHUDMobile() {
  const walking = useGameStore((s) => s.tunnelWalking);
  const stamina = useGameStore((s) => s.tunnelStamina);
  const toast = useGameStore((s) => s.careerToast);
  const toastAt = useGameStore((s) => s.careerToastAt);
  const clearToast = useGameStore((s) => s.clearCareerToast);
  const exitBeat = useTunnelExitStore((s) => s.beat);
  const [showGuide, setShowGuide] = useState(false);
  const [objectiveReady, setObjectiveReady] = useState(false);
  const [, setChromeDimmed] = useState(false);

  const staminaLit = Math.round(Math.max(0, Math.min(1, stamina)) * STAMINA_SEGS);

  const dismissGuide = () => {
    setShowGuide(false);
    setObjectiveReady(true);
  };

  useEffect(() => {
    if (!walking) {
      setShowGuide(false);
      setObjectiveReady(false);
      return;
    }
    setShowGuide(false);
    setObjectiveReady(false);
    const show = window.setTimeout(() => setShowGuide(true), 4500);
    return () => window.clearTimeout(show);
  }, [walking]);

  useEffect(() => {
    if (!toast || !toastAt) return;
    const id = window.setTimeout(() => {
      clearToast();
    }, 2300);
    return () => window.clearTimeout(id);
  }, [toast, toastAt, clearToast]);

  if (!walking) return null;
  if (exitBeat !== 'fp') return null;

  return (
    <div className="tunnel-m">
      <TunnelObjectiveTip compact ready={objectiveReady} />
      <NextSkillCard compact />

      <div className="tunnel-m__stamina">
        <span>Stamina</span>
        <div
          className="tunnel-m__stamina-segs"
          aria-label={`Stamina ${Math.round(stamina * 100)}%`}
        >
          {Array.from({ length: STAMINA_SEGS }, (_, i) => {
            const on = i < staminaLit;
            const peak = on && i >= staminaLit - 2 && staminaLit > 2;
            return (
              <i
                key={i}
                className={`${on ? 'is-on' : ''}${peak ? ' is-peak' : ''}`.trim()}
              />
            );
          })}
        </div>
      </div>

      {showGuide && (
        <div className="tunnel-m__guide" role="dialog" aria-label="Tunnel controls">
          <div className="tunnel-m__guide-top">
            <p className="tunnel-m__guide-kicker">How to walk</p>
            <button
              type="button"
              className="tunnel-m__guide-skip"
              onClick={dismissGuide}
            >
              Skip
            </button>
          </div>
          <div className="tunnel-m__guide-row">
            <div>
              <strong>Move</strong>
              <p>Left stick — walk</p>
            </div>
            <div>
              <strong>Look</strong>
              <p>Drag right side to turn</p>
            </div>
          </div>
          <button
            type="button"
            className="tunnel-m__guide-go"
            onClick={dismissGuide}
          >
            Got it
          </button>
        </div>
      )}

      <MobileTouchControls
        showPower={false}
        showActions={false}
        dimAfterLearn
        onDimmed={() => setChromeDimmed(true)}
      />
    </div>
  );
}
